import { useQuery } from "@tanstack/react-query";
import { fetchVesselParticularsApi } from "@/API/fetchVesselParticularsApi";
import { VesselParticularsType } from "@/types/apiTypes";
import { useLoadingContext } from "@/hooks/contextHooks/useLoadingContext";
import { ShowNotification } from "@/components/ShowNotification";

export const useFetchVesselParticulars = (vesselType: string) => {
  const { startLoading, stopLoading } = useLoadingContext();

  return useQuery<VesselParticularsType[], Error>({
    queryKey: ["vesselParticulars", vesselType],
    queryFn: async () => {
      startLoading();

      try {
        return await fetchVesselParticularsApi(vesselType);
      } catch (error) {
        ShowNotification({
          title: "Error",
          message: "Failed to fetch vessel particulars.",
          color: "error",
        });
        throw error;
      } finally {
        stopLoading();
      }
    },
    enabled: Boolean(vesselType),
  });
};
